<template>
  <v-dialog v-model="visible" max-width="800px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Aprobación de Solicitud de Inscripción</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12">
              <v-select
                :items="universidades"
                v-model="universidadId"
                item-text="nombre"
                item-value="id"
                label="Universidad"
                outlined
                dense
                placeholder="Seleccione"
                hide-details
                clearable
                :disabled="!!item?.programa?.programaUniversidad"
                @change="obtenerProgramasUniversidades" />
            </v-col>

            <v-col cols="12">
              <vue-select
                v-model="programaUniversidadId"
                class="style-chooser"
                placeholder="Seleccione un Programa Universidad"
                :options="programasUniversidades"
                label="programaNombre"
                :reduce="(option) => option.id"
                :filterable="false"
                :append-to-body="true"
                :disabled="!universidadId || !!item?.programa?.programaUniversidad"
                :selectable="(option) => option.estado == estadosProgramasUniversidades.PENDIENTE"
                @search="busquedaProgramaUniversidad">
                <template #header>
                  <div>Programa Universidad (Buscar por Codigo o Nombre Programa)</div>
                </template>

                <template
                  #option="{ codigo, programaNombre, resolucionAprobacionUniversidad, sedeUniversidad, estado }">
                  <div style="margin-bottom: 0.25rem">
                    <span style="display: block; font-size: 1rem">{{ codigo }} - {{ programaNombre }}</span>
                    <small style="display: block">
                      <strong>Sede Univ. </strong>{{ sedeUniversidad.nombre }} <strong>Resolución </strong
                      >{{ resolucionAprobacionUniversidad }}
                    </small>
                    <small style="display: block"> <strong>Estado </strong>{{ estado.toUpperCase() }} </small>
                  </div>
                </template>
              </vue-select>

              <small v-for="error in errores.programaUniversidadId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando || item.estado == estadosSolicitudesInscripciones.APROBADA"
          :loading="enviando"
          @click.prevent="$refs.confirmacionRef.abrir()">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import establecerProgramaUniversidadMixin from '../mixins/establecer-programa-universidad.mixin';
import SolicitudInscripcionService from '../services/solicitud-inscripcion.service';
import { concatenar, formatearErrores } from '../utils/funciones';

export default {
  name: 'ModalFormularioAprobarSolicitudInscripcion',
  mixins: [establecerProgramaUniversidadMixin],
  data() {
    return {
      confirmacion: {
        titulo: 'Aprobar Solicitud de Inscripción',
        mensaje: '¿Está seguro de aprobar la solicitud de inscripción?',
        realizandoAccion: false,
        fnAceptar: () => this.aprobar(),
      },
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        programaId: null,
        programa: null,
        programaUniversidadId: null,
        programaUniversidad: null,
        numeroSolicitud: null,
        fechaSolicitud: null,
        solicitanteId: null,
        nombreSolicitante: null,
        creadoEn: null,
        actualizadoEn: null,
        detallesSolicitudesInscripciones: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        programaId: data.programaId,
        programa: data.programa,
        programaUniversidadId: data.programaUniversidadId,
        programaUniversidad: data.programaUniversidad,
        numeroSolicitud: data.numeroSolicitud,
        fechaSolicitud: data.fechaSolicitud,
        solicitanteId: data.solicitanteId,
        nombreSolicitante: data.nombreSolicitante,
        creadoEn: data.creadoEn,
        actualizadoEn: data.actualizadoEn,
        detallesSolicitudesInscripciones: data.detallesSolicitudesInscripciones,
      };
    },
    abrir(data = null) {
      this.item = this.generarObjetoFormEditar(data);
      if (data?.programa?.programaUniversidad) {
        this.universidadId = data.programa?.programaUniversidad?.sedeUniversidad?.universidadId;
        this.programaUniversidadId = data.programa?.programaUniversidad?.id;
      } else {
        this.universidadId = data.programa?.universidadId;
        this.programaUniversidadId = null;
      }
      this.obtenerUniversidades();
      this.obtenerProgramasUniversidades();
      this.visible = true;
    },
    async aprobar() {
      this.enviando = true;

      try {
        await SolicitudInscripcionService.aprobar(this.item.id, {
          programaId: this.item.programaId,
          programaUniversidadId: this.programaUniversidadId,
          atendidoPor: concatenar(
            this.$store.state.DATA_USER.nombres,
            this.$store.state.DATA_USER.pri_apellido,
            this.$store.state.DATA_USER.seg_apellido,
          ),
          atendidoPorId: this.$store.state.DATA_USER.id,
        });

        this.cerrar();
        this.$emit('cerrar');
        this.$notify({
          group: 'notifications',
          title: 'Aprobación de Solicitud de Inscripción',
          text: 'Solicitud de inscripción aprobada con éxito',
          type: 'success',
        });
      } catch (error) {
        const errores = error?.response?.data?.errores;
        this.errores = errores;
        const erroresFormateados = formatearErrores(errores);

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Aprobación de Solicitud de Inscripción',
          text: erroresFormateados,
          type: 'error',
        });
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>